<template>
    <li class="dropdown user-box list-inline-item">
        <a href="" class="dropdown-toggle waves-effect waves-light profile" data-toggle="dropdown" aria-expanded="true">
            <i id="user-menu-icon" class="fa fa-bars"/>
            <div class="user-status away">
                <i class="zmdi zmdi-dot-circle"/>
            </div>
        </a>

        <ul class="dropdown-menu dropdown-menu-right">
            <li>
                <a href="javascript:void(0)" class="dropdown-item">
                    <i class="fa fa-user m-r-5"/>
                    <span v-html="$t('UserMenu.profile')"/>
                </a>
            </li>
            <li>
                <a href="javascript:void(0)" class="dropdown-item">
                    <i class="fas fa-cogs m-r-5"/>
                    <span v-html="$t('UserMenu.settings')"/>
                </a>
            </li>
            <li>
                <a href="#" @click.prevent="logOutUser" class="dropdown-item">
                    <i class="fa fa-power-off m-r-5"/>
                    <span v-html="$t('UserMenu.logout')"/>
                </a>
            </li>
        </ul>
    </li>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "UserMenu",
    methods: {
        ...mapActions("user", {
            logOutUser: "logout",
        }),
    },
};
</script>

<style scoped>
    #user-menu-icon {
        font-size: 23px;
        padding-top: 17px;
        color: white;
    }
</style>